<template>
  <v-dialog v-model="dialog" max-width="500" :persistent="mutationLoading">
    <template v-slot:activator="{ on }">
      <v-btn class="ml-2" v-on="on" v-bind="$attrs" color="success">Create folder</v-btn>
    </template>

    <v-card :loading="mutationLoading">
      <v-card-title>
        <span class="title">Create folder</span>
      </v-card-title>

      <v-card-text>
        <v-form v-model="valid" @submit.prevent="create">
          <v-row no-gutters>
            <v-col>
              <v-text-field outlined dense v-model="directoryName" label="name"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="success" @click="create" :loading="mutationLoading" text>Save</v-btn>

        <v-btn color="error" @click="close" text>Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createMediaDirectory } from '@/graphql/media.gql'

export default {
  name: 'CreateDirectory',
  inheritAttrs: true,
  props: {
    path: {
      type: String,
      required: true
    }
  },
  data: () => ({
    dialog: false,
    valid: false,
    directoryName: null,
    mutationLoading: false
  }),
  methods: {
    create() {
      this.mutationLoading = true

      this.$apollo
        .mutate({
          mutation: createMediaDirectory,
          variables: {
            data: {
              path: this.path,
              name: this.directoryName
            }
          }
        })
        .then(data => {
          let response = data.data.createMediaDirectory

          this.handleGraphQLSuccess(response.message)

          this.dialog = false

          this.$emit('created')

          this.mutationLoading = false
        })
        .catch(error => {
          this.handleGraphQLErrors(error)

          this.mutationLoading = false
        })
    },
    close() {
      this.dialog = false
      this.$emit('closed')
    }
  }
}
</script>
